import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useStorageOtherStore } from "../store/StorageStore";
import { ColumnItem } from "../../../common/models/table";
import { Loader } from "../../../common/components/Loader/Loader";
import { LFTableV3 } from "../../../common/components/LFTable/LFTableV3";
import { ActionsKey } from "../../../common/models/Actions";
import { CustomDrawer } from "../../../common/components/Drawer/CustomDrawer";
import { HttpStatusCode } from "axios";
import { ManifestoService } from "../../operations/core/_request";
import StorageOtherDetail from "./forms/StorageOtherDetail";
import CustomModal from "../../../common/components/Modal/CustomModal";
import CustomerRemovalForm from "./forms/CustomerRemovalForm";
import { StorageService } from "../core/_request";
import { FaTruckArrowRight } from "react-icons/fa6";
import { AiOutlineFilePdf } from "react-icons/ai";
import { downloadPDF } from "../../../utilities/downloadPdf";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

interface StorageOtherListProps {
  storageType: string;
}

const StorageOtherList = ({ storageType }: StorageOtherListProps) => {
  const [isShowForm, setIsShowForm] = useState<boolean>(false);

  const {
    list: otherList,
    setList: setOtherList,
    pageState,
    actioned,
    setActioned,
    setPageState,
    totalItems,
    resetPageState,
  } = useStorageOtherStore();

  const { id } = useParams();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [modalData, setModalData] = useState({});

  const [isDownloading, setIsDownloading] = useState<boolean>(false);
  const idPdf = (otherList as any)[0]?.["@id"]?.split("/").pop();

  const cols: ColumnItem[] = [
    {
      key: "description",
      title: "Description",
      dataIndex: "description",
      show: true,
      // isCanSort: true,
    },
    {
      key: "tonnage",
      title: "Tonnage (T)",
      dataIndex: "tonnage",
      show: true,
      // isCanSort: true,
    },
  ];

  useEffect(() => {
    fetchRequest();
  }, [pageState]);

  const fetchRequest = (params?: any) => {
    getMovement("api/other_loads", {
      ...pageState,
      "storageLoads.storage": id,
      "storageLoads.storageLoadState": ["IN", "RETURNED"],

      ...params,
    });
  };

  const getMovement = async (url: string, params: any) => {
    try {
      setIsLoading(true);

      const res = await ManifestoService.getAllMouvement(url, params);

      if (res?.status === HttpStatusCode.Ok) {
        setOtherList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onShowAddHandler = () => {
    setIsShowForm((prev: boolean) => !prev);
  };

  const onFinishAction = () => {
    setIsOpenModal(false);
    fetchRequest({ page: 1 });
    setPageState({
      ...pageState,
      page: 1,
    });
  };

  const handleOpenModal = () => {
    if (!isOpenModal) {
      getStorageLoad({
        ...pageState,
        storageLoadState: "IN",
        storage: id,
        //"uniqueIdentifierLoad": otherList[0]?.batchNumber
      });
    }
    setIsOpenModal((prev: boolean) => !prev);
  };

  const getStorageLoad = async (params: any) => {
    try {
      setIsLoading(true);
      const res = await StorageService.getStorageLoadList(params);
      if (res.status === HttpStatusCode.Ok) setModalData(res?.data?.member[0]);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadClick = async () => {
    try {
      setIsDownloading(true);
      await downloadPDF(`/api/other_loads/${idPdf}/EIR`, `other_${idPdf}.pdf`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div>
      <div>
        <Loader isLoading={isLoading} />
        <LFTableV3
          columns={cols}
          data={otherList}
          params={pageState}
          onAction={(record: any, actionType: ActionsKey) => {
            if (actionType === "read") {
              setActioned({ action: actionType, data: record });
              setIsShowForm(true);
            }
          }}
          isCanShow={() => true}
          onSearch={(search: any) => {
            setPageState(search);
          }}
          onSort={(sort: any) => {
            setPageState(sort);
          }}
          onResetSearch={() => {
            resetPageState();
          }}
          pagination={{
            defaultCurrentPage: pageState.page,
            itemsPerPage: pageState?.itemsPerPage,
            totalItems: totalItems,
          }}
          onChangePage={(e: any) => setPageState(e)}
          otherActions={[
            (row) => (
              <div className="" onClick={handleOpenModal}>
                <FaTruckArrowRight title="Enlèvement client" />
              </div>
            ),
            ({ row }) => (
              <div className="">
                {(!row?.imported && storageType!=="StoreStorage") ? (
                  <>
                    {isDownloading ? (
                      <Spin indicator={<LoadingOutlined spin />} size="small" />
                    ) : (
                      <AiOutlineFilePdf
                        title="Générer EIR"
                        onClick={handleDownloadClick}
                      />
                    )}
                  </>
                ) : (
                  ""
                )}
              </div>
            ),
          ]}
        />
      </div>

      {/* Drawer section  */}
      {isShowForm ? (
        <CustomDrawer
          isOpen={isShowForm}
          onClose={onShowAddHandler}
          title={
            actioned?.action === "read"
              ? "Détails"
              : actioned?.action === "update"
              ? "Modification"
              : "Nouvau"
          }
          width={"75%"}
        >
          <StorageOtherDetail
            {...{
              initialValue: actioned?.data,
              type: actioned?.action,
            }}
          />
        </CustomDrawer>
      ) : (
        ""
      )}

      {/* Modal section */}
      {isOpenModal && (
        <CustomModal
          isOpen={isOpenModal}
          hanldeCloseModal={handleOpenModal}
          title="Enlèvement client"
        >
          <CustomerRemovalForm
            onFinish={onFinishAction}
            initialValue={modalData}
          />
        </CustomModal>
      )}
    </div>
  );
};

export default StorageOtherList;
